export const BlogCategoryEnum = {
  PROMOTIONS: 3,
  NEWS: 4,
  NOTIFICATIONS: 8
} as const;
